import { Element } from '@@editor/helpers';
import { type CSSlideshowElement } from '@@editor/helpers/Element';
import { isUnityCSSlideshow, type UnityCSSlideshow } from '@@editor/typings/UnityElements';

import { CURRENT_VERSION } from '../constants';
import { type ElementRule } from '../types';
import { createElement } from './../deserializeNodes';

type Rule = ElementRule<CSSlideshowElement, UnityCSSlideshow>;

const legacyImportRules: Rule = {
    deserialize: (element): ReturnType<Rule['deserialize']> => {
        if (isUnityCSSlideshow(element)) {
            const { type, ...data } = element;

            return createElement(type, data);
        }
    },

    serialize: (node): ReturnType<Rule['serialize']> => {
        if (Element.isCSSlideshowElement(node)) {
            const { type, data } = node;

            // @ts-expect-error No idea why this works, but it does. Since it is legacy code,
            // we do not care about correct typing that much.
            return {
                ...data,
                version: CURRENT_VERSION,
                type,
            };
        }
    },
};

export default legacyImportRules;
